import {
  NavbarFloatingCurrentOrderContainer,
  NavbarFloatingCurrentOrderLinkPressable,
} from './components';

// ─────────────────────────────────────────────────────────────────────────────

export const NavbarFloatingCurrentOrder = {
  Container: NavbarFloatingCurrentOrderContainer,
  LinkPressable: NavbarFloatingCurrentOrderLinkPressable,
};
